import style from './style.css';

const Collapsed = ({
  children,
  handleOpen,
  id,
  isLast,
  open,
  item,
  isNoCostAvailable,
  isContextCard,
}) => {
  return (
    <div
      className={`${
        isContextCard
          ? style.contextCollapsedContainer
          : style.collapsedContainer
      } ${
        isContextCard
          ? style.contextCollapsedContainerBottom
          : isLast
          ? open === id && style.collapsedContainerBottom
          : style.collapsedContainerBottom
      }`}
      onClick={() => handleOpen(id, item)}
      data-id={id}>
      {children}
      <div className={style.rightContent}>
        {isNoCostAvailable && <div className={style.noCostTag}>No Cost</div>}
        <div className={`material-icons ${style.iconInCollapse}`}>
          {open === id ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}{' '}
        </div>
      </div>
    </div>
  );
};

export default Collapsed;



// WEBPACK FOOTER //
// ./components/accordion/collapsed.js